import fi from "./fi";

const dateTimeFormat = {
    date: { year: "numeric", month: "long", day: "numeric", hour12: false },
    time: { hour: "numeric", minute: "numeric", second: "numeric", hour12: false },
    full: {
        year: "numeric", month: "long", day: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric", hour12: false,
    },
};

const numberFormat = {
    currency: { style: "currency", currency: "EUR" },
};

export default {
    enabledLocales: [ "fi" ],
    messages: { fi },
    dateTimeFormats: {
        fi: dateTimeFormat,
    },
    numberFormats: {
        fi: numberFormat,
    },
} as any;
